(function () {
  'use strict';

  function updateRailState(grid) {
    const canScroll = grid.scrollWidth - grid.clientWidth > 2;
    grid.classList.toggle('configurator__grid--scrollable', canScroll);
    grid.classList.toggle('configurator__grid--at_end', grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2);
  }

  function updateAllRailStates() {
    document.querySelectorAll('.js_configurator_grid').forEach(updateRailState);
  }

  function initConfiguratorCard(configurator) {
    if (configurator.dataset.configuratorInit === '1') {
      return;
    }
    configurator.dataset.configuratorInit = '1';

    configurator.addEventListener('click', function (event) {
      const option = event.target.closest('.js_configurator_option');
      if (!option || option.classList.contains('active')) {
        return;
      }
      if (option.dataset.url && typeof window.goTo === 'function') {
        window.goTo(option.dataset.url, option.dataset.filter, option);
        return;
      }
      if (typeof option.dataset.ok !== 'undefined' && typeof window.goToOk === 'function') {
        window.goToOk(Number(option.dataset.ok), option);
      }
    });

    configurator.querySelectorAll('.js_configurator_grid').forEach(function (grid) {
      updateRailState(grid);
      grid.addEventListener(
        'scroll',
        function () {
          updateRailState(grid);
        },
        { passive: true },
      );
    });
  }

  function initConfigurator() {
    document.querySelectorAll('.js_configurator').forEach(initConfiguratorCard);
  }

  initConfigurator();
  window.initConfigurator = initConfigurator;
  window.addEventListener('resize', updateAllRailStates);
})();
